const features = [
  {
    icon: 'ri-shield-check-fill',
    title: '安全纯净观影',
    desc: '全站无弹窗广告、无恶意跳转，纯净观影环境让你专注享受每一部最新电影，不受任何打扰。',
  },
  {
    icon: 'ri-speed-up-fill',
    title: '极速加载不缓冲',
    desc: '全球CDN加速节点覆盖，智能预加载技术确保高清免费在线观看流畅不卡顿，即点即播。',
  },
  {
    icon: 'ri-smartphone-fill',
    title: '全设备无缝适配',
    desc: '电脑、平板、手机全端自适应，随时随地打开68影院即可享受高清电影，观影不设限。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            为什么选择68影院
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            三大核心优势，重新定义你的在线观影方式
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-7 text-center hover:border-primary-300/40 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className={`${feat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}